import { useEffect, useMemo, useState } from 'react';
import RegistryViewModal from './RegistryViewModal';
import { useReportContext } from '../../../../context/DetailContext';
import { useUser } from '../../../../context/UserContext';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../../../context/ModalContext';
import BottomModal from '../../../components/modal/BottomModal';
import QuotaService from '../../../../service/quota/Quota';
import { isFinalMonth } from '../../../../utils/auth';
import PageModal from '../../../components/modal/PageModal';

interface Props {
  type: string;
  link: string;
  onClose: () => void;
}

type AccessCase =
  | 'HAS_TICKETS'
  | 'NO_TICKETS'
  | 'NO_TICKETS_LAST_MONTH'
  | 'LIMIT';

function RegistryModal({ type, link, onClose }: Props) {
  const navigate = useNavigate();

  const { iidx } = useReportContext();
  const { user } = useUser();
  const { modalDispatch, modal } = useModal();
  const [quotaAccess, setQuotaAccess] = useState<boolean | null>(null); // 이용권 소진 여부

  // 서비스 이용권 확인
  const getServiceQuotaCheck = async (type: string, iidx: number) => {
    try {
      const res = await QuotaService.check(type, iidx);
      setQuotaAccess(res.data);
    } catch (err) {
      console.log(err, '발생');
      return false;
    }
  };

  const accessCase: AccessCase = useMemo(() => {
    if (quotaAccess) return 'HAS_TICKETS';
    if (!user || !user.plan_grade) return 'LIMIT';
    if (isFinalMonth(user?.plan_end)) {
      return 'NO_TICKETS_LAST_MONTH';
    }
    return 'NO_TICKETS';
  }, [quotaAccess, user]);

  useEffect(() => {
    getServiceQuotaCheck(type, Number(iidx));
  }, [type, iidx]);

  useEffect(() => {
    if (quotaAccess === null) return;
    if (accessCase === 'HAS_TICKETS') {
      modalDispatch({ type: 'USER_ALERT_CLOSE' });
      return;
    }

    if (accessCase === 'NO_TICKETS') {
      modalDispatch({ type: 'USER_ALERT', payload: 'quotaDepleted' });
      onClose();
    } else if (accessCase === 'NO_TICKETS_LAST_MONTH') {
      modalDispatch({ type: 'USER_ALERT', payload: 'quotaDepletedExpiring' });
      onClose();
    } else {
      modalDispatch({ type: 'USER_ALERT', payload: 'free' });
      onClose();
    }
  }, [quotaAccess, accessCase, modalDispatch]);

  if (accessCase === 'HAS_TICKETS') {
    return (
      <PageModal open={true} onClose={onClose}>
        <RegistryViewModal type={type} onClose={onClose} link={link} />
      </PageModal>
    );
  }
  return null;
}

export default RegistryModal;
